import type { ReactNode } from 'react'

import { SyntaxHighlighter } from 'components/SyntaxHighlighter'

type Props = {
	children?: ReactNode
	className?: string
}

export const Code = ({ children, className, ...rest }: Props) => {
	const language = /language-(\w+)/.exec(className || '')

	if (language && typeof children === 'string') {
		return (
			<SyntaxHighlighter {...rest} language={language[1]} showLineNumbers={false}>
				{children.replace(/\n$/, '')}
			</SyntaxHighlighter>
		)
	}

	return (
		<code {...rest} className={className}>
			{children}
		</code>
	)
}
